"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GenericRepo_1 = __importDefault(require("./GenericRepo"));

var PickingsRepo =
/** @class */
function (_super) {
  __extends(PickingsRepo, _super);

  function PickingsRepo(app, coll, user) {
    var _this = _super.call(this, coll, user) || this;

    _this.app = app;
    return _this;
  }

  PickingsRepo.prototype.create = function (ids) {
    var _this = this;

    return this.ensureObjectIds(ids).then(function (ids) {
      return _this.app.callFunction("createPicking", [ids]);
    });
  };

  PickingsRepo.prototype.build = function (id) {
    var _this = this;

    return this.ensureObjectId(id).then(function (id) {
      return _this.app.callFunction("buildPicking", [id]);
    });
  };

  return PickingsRepo;
}(GenericRepo_1.default);

exports.default = PickingsRepo;